import {
  forwardRef,
  Icon as ChakraIcon,
  type IconProps as ChakraIconProps,
  type ComponentWithAs,
} from '@chakra-ui/react';

export type IconProps = ChakraIconProps & {
  size?: string | number;
};

export const Icon: ComponentWithAs<'svg', IconProps> = forwardRef<
  IconProps,
  'svg'
>((props, forwardedRef) => {
  const { width, height, boxSize, size, ...rest } = props;

  // To support icons with mixed aspect ratios, set either
  // width or height, and let the icon drive the other dimension.
  //
  // Or use boxSize to set both at once, to fit icons into
  // a consistent box.
  const squareSize = boxSize ?? size;

  const dimensions =
    squareSize != null
      ? { width: squareSize, height: squareSize }
      : {
          width: width ?? (height ? 'auto' : undefined),
          height: height ?? (width ? 'auto' : undefined),
        };

  return <ChakraIcon ref={forwardedRef} {...dimensions} {...rest} />;
});

Icon.displayName = 'Icon';
